module.exports = __webpack_public_path__ + "static/media/1.d49036d6.svg";